import { useEffect } from "react";

export default function Terms() {
  useEffect(() => { document.title = "Terms — Toriano Sanzone"; window.scrollTo(0, 0); }, []);
  return (
    <div className="pt-[140px] pb-24 max-w-3xl mx-auto px-6" data-testid="terms-page">
      <div className="text-eyebrow text-gold mb-4">Terms of Use</div>
      <h1 className="font-display text-5xl mb-8">Terms.</h1>
      <div className="space-y-5 text-bone/80 font-editorial leading-relaxed">
        <p>All content on this site — text, imagery, brand assets, the TS monogram, and the Wolfkeeper method — is the property of Toriano Sanzone and its affiliated ventures. Reproduction without written permission is prohibited.</p>
        <p>Booking a service constitutes agreement to the specific service terms provided during intake. Nonprofit donations to Golden Wolf Foundation are separate from commercial dog-training services.</p>
        <p>Questions: <a href="mailto:info@torianosanzone.com" className="text-gold">info@torianosanzone.com</a> · 312.933.1528</p>
      </div>
    </div>
  );
}
